module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<form id=\"user_edit_info\"> <div class=\"form-group\"> <div class=\"panel\"> <label>First &amp; Last Name <small class=\"text-muted\">(Requires at least two words)</small></label> <input type=\"text\" placeholder=\"First &amp; Last Name\" class=\"form-control form-control-lg\" id=\"user_name\" value=\"")
    ; __append(escapeFn( locals.name ))
    ; __append("\"> </div> </div> <div class=\"form-group\"> <div class=\"panel\"> <label>Phone Number <small class=\"text-muted\">(Minimum 6 digits. Include country and area codes)</small></label> <input type=\"text\" placeholder=\"Phone Number\" class=\"form-control form-control-lg\" id=\"user_phone_number\" value=\"")
    ; __append(escapeFn( locals.phone_number ))
    ; __append("\"> </div> </div> <button type=\"submit\" class=\"btn btn-red\">Update Account Info</button> </form> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/user_edit_info.ejs
// module id = 916
// module chunks = 1